
// src/actions/socket.js

import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const SOCKET_CONNECT = "SOCKET_CONNECT"
export const SOCKET_RECONNECT = "SOCKET_RECONNECT"
export const SOCKET_RECONNECTING = "SOCKET_RECONNECTING"
export const SOCKET_RECEIVE = "SOCKET_RECEIVE"
export const SOCKET_DISCONNECT = "SOCKET_DISCONNECT"

export function socketConnect() {
  return {
    type: SOCKET_CONNECT,
  }
}

export function socketReconnect() {
  return {
    type: SOCKET_RECONNECT,
  }
}

export function socketReconnecting() {
  return {
    type: SOCKET_RECONNECTING,
  }
}

export function socketDisconnect() {
  return {
    type: SOCKET_DISCONNECT,
  }
}

export function socketReceive(message_type, params) {
  return {
    type: SOCKET_RECEIVE,
    message_type, params,
  }
}



// WEBPACK FOOTER //
// ./src/actions/socket.js